<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, minValue, maxValue } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      authToken: '',
      pollingInterval: 30,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    authToken: { required },
    pollingInterval: {
      required,
      minValue: minValue(10),
      maxValue: maxValue(300),
    },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const promChannel = await this.$store.dispatch('inboxes/createChannel', {
          channel: {
            type: 'prom',
            auth_token: this.authToken,
            polling_interval: this.pollingInterval,
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: promChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.PROM_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.PROM_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.PROM_CHANNEL.DESC')"
    />
    <form class="flex flex-wrap flex-col mx-0" @submit.prevent="createChannel()">
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.authToken.$error }">
          {{ $t('INBOX_MGMT.ADD.PROM_CHANNEL.AUTH_TOKEN.LABEL') }}
          <input
            v-model="authToken"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.PROM_CHANNEL.AUTH_TOKEN.PLACEHOLDER')"
            @blur="v$.authToken.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.PROM_CHANNEL.AUTH_TOKEN.SUBTITLE') }}
        </p>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label :class="{ error: v$.pollingInterval.$error }">
          {{ $t('INBOX_MGMT.ADD.PROM_CHANNEL.POLLING_INTERVAL.LABEL') }}
          <input
            v-model.number="pollingInterval"
            type="number"
            min="10"
            max="300"
            :placeholder="$t('INBOX_MGMT.ADD.PROM_CHANNEL.POLLING_INTERVAL.PLACEHOLDER')"
            @blur="v$.pollingInterval.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.PROM_CHANNEL.POLLING_INTERVAL.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.PROM_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

